import AdaptiveStatic from './adaptive-static';

export default AdaptiveStatic;
